import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Switch, FormControlLabel, Button, Typography, BaseDialog, DialogActions } from '@metarouter-private/mr-mui';
import { useUpdateWebhookConfig } from '@ion/api';

export default function EnableDisableToggle({ webhookConfig }) {
  const isEnabled = Boolean(webhookConfig.enabledAt);
  const [disabling, setDisabling] = useState(null);
  const [updateConfig, { loading }] = useUpdateWebhookConfig({
    onCompleted: () => setDisabling(null),
  });

  const handleOpen = () => setDisabling(isEnabled);

  const handleConfirm = () => {
    updateConfig({
      webhookConfigId: webhookConfig.id,
      enabled: !isEnabled,
    });
  };

  return (
    <>
      <FormControlLabel
        label={isEnabled ? 'Enabled' : 'Disabled'}
        control={<Switch checked={isEnabled} onChange={handleOpen} disabled={loading} />}
      />
      <BaseDialog
        DialogProps={{ open: disabling !== null, onClose: () => setDisabling(null) }}
        title={disabling ? 'Disable Webhook' : 'Enable Webhook'}
        content={
          <Typography variant="body2">
            {disabling
              ? 'Your webhook will stop receiving events. You can re-enable it at any time.'
              : 'Your webhook will begin receiving events at the configured URL.'}
          </Typography>
        }
        actions={
          <DialogActions>
            <Button variant="outlined" color="secondary" onClick={() => setDisabling(null)}>
              Cancel
            </Button>
            <Button variant="contained" onClick={handleConfirm} disabled={loading}>
              {disabling ? 'Disable' : 'Enable'}
            </Button>
          </DialogActions>
        }
      />
    </>
  );
}

EnableDisableToggle.propTypes = {
  webhookConfig: PropTypes.shape({
    id: PropTypes.string.isRequired,
    enabledAt: PropTypes.string,
  }).isRequired,
};
